import React, { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { useGetLocalesQuery } from '../../../redux/services/api';
import { addFormGroup, selectFieldGroups, selectFormFieldGroupLength } from '../../../redux/slices/form-builder-slice';
import DnDFormBuilder from '../dnd/dnd-form-builder.component';
import FormBuilderGroupWrapper from '../dnd/form-builder-group-wrapper';
import FormBuilderAddButton from '../form-builder-add-button.component';
import FormBuilderHierarchy from '../form-builder-hierarchy.component';
import { createTranslations } from '../form-builder-utils';

const FormBuilderFields = () => {
  const fieldGroups = useAppSelector(selectFieldGroups);
  const formFieldGroupLength = useAppSelector(selectFormFieldGroupLength);
  const dispatch = useAppDispatch();

  const { data: locales } = useGetLocalesQuery();

  const onAddGroupClick = useCallback(() => {
    dispatch(
      addFormGroup({
        caption: { translations: createTranslations('New Section', locales ?? []) },
        position: formFieldGroupLength + 1,
        fields: [],
        displayType: 'EXPAND',
        removed: false,
        uuid: crypto.randomUUID(),
      })
    );
  }, [dispatch, locales, formFieldGroupLength]);

  return (
    <div className="w-full">
      <FormBuilderHierarchy />
      <DnDFormBuilder fieldGroups={fieldGroups}>
        {fieldGroups.map((group) => (
          <FormBuilderGroupWrapper key={group.id ?? group.uuid} groupId={(group.id ?? group.uuid)!} />
        ))}
      </DnDFormBuilder>
      <FormBuilderAddButton onClick={onAddGroupClick} label="Add Section" />
    </div>
  );
};

export default React.memo(FormBuilderFields);
